import React from 'react';
import { Divider } from '../../import';

const DividerWrapper = () => {
  return <Divider />;
};

export default DividerWrapper;
